import { ACCENT_COLOR } from '@/constants';

export const getPageNumbers = (currentPage, pageCount) => {
  const delta = 1;
  const pages = [];

  const rangeStart = Math.max(2, currentPage - delta);
  const rangeEnd = Math.min(pageCount - 1, currentPage + delta);

  pages.push(1);

  if (rangeStart > 2) pages.push('...');

  for (let i = rangeStart; i <= rangeEnd; i++) {
    pages.push(i);
  }

  if (rangeEnd < pageCount - 1) pages.push('...');

  if (pageCount > 1) pages.push(pageCount);

  return pages;
};

export const activePageStyle = {
  color: '#fff',
  borderColor: ACCENT_COLOR,
  backgroundColor: ACCENT_COLOR,
};

export const pageLinkStyle = {
  color: ACCENT_COLOR,
};
